import { Expose } from "class-transformer";
import { EmployeeVoiceBase } from "domain/model/base";
import Attachment from 'domain/model/attachment';

export default class EmployeeVoice extends EmployeeVoiceBase {
  @Expose({name: "attachment"})
  attachment: Attachment;
};
